<template>
    <div class="box mt-5">
        <h2 class="title is-4">Checkride History</h2>
        <div class="table-container">
            <table class="table is-fullwidth is-striped is-hoverable has-text-centered">
                <thead>
                    <tr>
                        <th class="has-text-centered">Date</th>
                        <th class="has-text-centered">Time</th>
                        <th class="has-text-centered">Routing</th>
                        <th class="has-text-centered">Tail #</th>
                        <th class="has-text-centered">Primary</th>
                        <th class="has-text-centered">SIC</th>
                        <th class="has-text-centered">Check Airman</th>
                        <th class="has-text-centered">Type</th>
                        <th class="has-text-centered">Actions</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(checkride, index) in checkrides" :key="index">
                        <td>{{ formatDate(checkride.scheduledDatetime) }}</td>
                        <td>{{ formatTime(checkride.scheduledDatetime) }}</td>
                        <td>{{ checkride.routing }}</td>
                        <td>
                            <span v-if="checkride.tailNumber">{{ checkride.tailNumber }}</span>
                            <span v-else class="has-text-grey-light">—</span>
                        </td>
                        <td>
                            <span v-if="checkride.picName" class="tag" :class="checkride.picCheckResult ? 'is-success' : 'is-danger'">
                                {{ checkride.picName }}
                            </span>
                            <span v-else class="has-text-grey-light">Not assigned</span>
                        </td>
                        <td>
                            <span v-if="checkride.sicName" class="tag" :class="checkride.sicCheckResult ? 'is-success' : 'is-danger'">
                                {{ checkride.sicName }}
                            </span>
                        </td>
                        <td>
                            <span v-if="checkride.checkAirmanName" class="tag" :class="checkride.checkAirmanCheckResult ? 'is-success' : 'is-danger'">
                                {{ checkride.checkAirmanName }}
                            </span>
                            <span v-else class="has-text-grey-light">Not assigned</span>
                        </td>
                        <td>{{ checkride.type === 1 ? '299' : checkride.type === 2 ? '293' : checkride.type }}</td>
                        <td class="has-text-centered">
                            <button class="button is-small is-info" @click="$emit('view-checkride', checkride)">
                                <span class="icon is-small">
                                    <font-awesome-icon :icon="['fas', 'download']" />
                                </span>
                                <span>Download</span>
                            </button>
                        </td>
                    </tr>
                    <tr v-if="checkrides.length === 0">
                        <td colspan="9" class="has-text-centered">No checkrides found</td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="has-text-centered mt-3">
            <p class="has-text-grey is-size-7">
                Showing the most recent 20 checkrides only
            </p>
        </div>
    </div>
</template>

<script>
export default {
    name: 'CheckrideHistory',
    props: {
        checkrides: {
            type: Array,
            default: () => []
        }
    },
    emits: ['view-checkride'],
    setup() {
        const formatDate = (timestamp) => {
            if (!timestamp) return '';
            const options = { year: 'numeric', month: 'short', day: 'numeric' };
            return new Date(timestamp).toLocaleDateString(undefined, options);
        };

        const formatTime = (timestamp) => {
            if (!timestamp) return '';
            const options = { hour: '2-digit', minute: '2-digit' };
            return new Date(timestamp).toLocaleTimeString(undefined, options);
        };

        return {
            formatDate,
            formatTime
        };
    }
};
</script>